module.exports = __webpack_public_path__ + "img/skywrath_mage.2d1f71ec.png";